export default __webpack_public_path__ + "static/media/assignments-02.2abb80a3.svg";